import React, { useState } from 'react';
import { Modal } from './Modal';
import { PrivacyPolicy } from './PrivacyPolicy';
import { TermsConditions } from './TermsConditions';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const currentYear = new Date().getFullYear();
  return <>
      <footer className="bg-slate-950 py-10 border-t border-slate-800 text-center" data-id="element-16">
        <div className="max-w-4xl mx-auto px-4" data-id="element-17">
          <div className="flex flex-wrap justify-center items-center gap-4 mb-6 text-sm" data-id="element-18">
            <button onClick={() => setActiveModal('privacy')} className="text-slate-400 hover:text-slate-200 transition-colors focus:outline-none focus:underline" data-id="element-19">
              Política de Privacidad
            </button>
            <span className="text-slate-700" data-id="element-20">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-slate-400 hover:text-slate-200 transition-colors focus:outline-none focus:underline" data-id="element-21">
              Términos y Condiciones
            </button>
          </div>

          <div className="space-y-2 text-slate-500 text-sm" data-id="element-22">
            <p data-id="element-23">
              © {currentYear} Protocolo Adiós Insomnio 3AM. Todos los derechos
              reservados.
            </p>
            <p className="text-xs max-w-2xl mx-auto" data-id="element-24">
              Este producto no sustituye el consejo médico profesional. Los
              resultados pueden variar según la persona.
            </p>
          </div>
        </div>
      </footer>

      {/* Modals */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-25">
        <PrivacyPolicy data-id="element-26" />
      </Modal>

      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-27">
        <TermsConditions data-id="element-28" />
      </Modal>
    </>;
}